import { Settings } from "../storage/store";

// The app's four themes (app/screens/HomeSettings/ThemeSettings.js), by the
// id it saves.
export const THEMES = Object.freeze({ SYSTEM: "1", LIGHT: "2", DARK: "3", SMART: "4" });

const DARK_QUERY = "(prefers-color-scheme: dark)";

// Smart Theme follows the time of day, as the app's ColorThemeProvider does:
// dark from 18:00 until 5:00, light the rest of the day.
const smartMode = (date = new Date()) => {
  const hour = date.getHours();
  return hour >= 18 || hour < 5 ? "dark" : "light";
};

const systemMode = () => (window.matchMedia?.(DARK_QUERY).matches ? "dark" : "light");

export const modeFor = (themeId) => {
  if (themeId === THEMES.DARK) return "dark";
  if (themeId === THEMES.SYSTEM) return systemMode();
  if (themeId === THEMES.SMART) return smartMode();
  return "light";
};

// Sets data-theme on <html>; the stylesheets switch their colours on it.
export const applyTheme = (themeId = Settings.getThemeId()) => {
  const mode = modeFor(themeId);
  document.documentElement.dataset.theme = mode;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", mode === "dark" ? "#000000" : "#f1f9ff");
};

export const setTheme = (themeId) => {
  Settings.setThemeId(themeId);
  applyTheme(themeId);
};

// Keeps System Default and Smart Theme current: the system setting can change
// at any time, and Smart Theme turns over at 5:00 and 18:00.
export const watchTheme = () => {
  const media = window.matchMedia?.(DARK_QUERY);
  const update = () => applyTheme();
  media?.addEventListener?.("change", update);
  const timer = setInterval(update, 60 * 1000);
  return () => {
    media?.removeEventListener?.("change", update);
    clearInterval(timer);
  };
};
